import { toast } from 'react-toastify';

/**
 * Standardized Success Notification
 * Use for completed actions (e.g., Syllabus Generated, Assignment Graded).
 */
export const notifySuccess = (message) => {
  toast.success(message, {
    position: "top-right",
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
};

/**
 * Standardized Error Notification
 * Use for failures (e.g., AI Connection Error, Domain Breach).
 */
export const notifyError = (message) => {
  toast.error(message, {
    position: "top-right",
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
};

/**
 * Standardized Info Notification
 * Use for non-blocking updates (e.g., "Starting generation...", "Cache found").
 */
export const notifyInfo = (message) => {
  toast.info(message, {
    position: "top-right",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: "colored",
  });
};
